// extracted by mini-css-extract-plugin
export default {"dropdownItem":"DropdownItem_dropdownItem__4x0E7"};